import Vue from 'vue';
import Router from 'vue-router';

import RouterComponent from './components/RouterComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "start" */ './views/main/Start.vue'),
      children: [
        {
          path: 'about',
          component: () => import('./views/LandingPage.vue'),
        },
        {
          path: 'login',
          name: 'login',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
        },
        {
          path: 'recover-password',
          component: () => import(/* webpackChunkName: "recover-password" */ './views/PasswordRecovery.vue'),
        },
        {
          path: 'reset-password',
          component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
        },
        {
          path: 'sign-up/:id',
          component: () => import('./views/SignUp.vue'),
        },
        {
          path: 'main',
          name: 'main',
          component: () => import(/* webpackChunkName: "main" */ './views/main/Main.vue'),
          children: [
            {
              path: 'dashboard',
              component: () => import(/* webpackChunkName: "main-dashboard" */ './views/main/Dashboard.vue'),
            },
            {
              path: 'profile',
              component: RouterComponent,
              redirect: 'profile/view',
              children: [
                {
                  path: 'view',
                  component: () => import(
                    /* webpackChunkName: "main-profile" */ './views/main/profile/UserProfile.vue'),
                },
                {
                  path: 'edit',
                  component: () => import(
                    /* webpackChunkName: "main-profile-edit" */ './views/main/profile/UserProfileEdit.vue'),
                },
                {
                  path: 'password',
                  component: () => import(
                    /* webpackChunkName: "main-profile-password" */ './views/main/profile/UserProfileEditPassword.vue'),
                },
              ],
            },
            {
              path: 'admin',
              component: () => import(/* webpackChunkName: "main-admin" */ './views/main/admin/Admin.vue'),
              redirect: 'admin/users/all',
              children: [
                {
                  path: 'users',
                  redirect: 'users/all',
                },
                {
                  path: 'accounts',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminAccounts.vue'),
                },
                {
                  path: 'accounts/create',
                  name: 'main-admin-accounts-create',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/SignUp.vue'),
                },
                {
                  path: 'accounts/edit/:id',
                  name: 'main-admin-accounts-edit',
                  component: () => import(
                    './views/main/admin/EditAccount.vue'
                  ),
                },
                {
                  path: 'users/all',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminUsers.vue'),
                },
                {
                  path: 'users/edit/:id',
                  name: 'main-admin-users-edit',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users-edit" */ './views/main/admin/EditUser.vue'),
                },
                {
                  path: 'users/create',
                  name: 'main-admin-users-create',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users-create" */ './views/main/admin/CreateUser.vue'),
                },
                {
                  path: 'roles/all',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminRoles.vue'),
                },
                {
                  path: 'languages/all',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminLanguages.vue'),
                },
                {
                  path: 'features',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminSystemFeatures.vue'),
                },
                {
                  path: 'catalogues',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminCatalogues.vue'),
                },
                {
                  path: 'sponsors',
                  name: 'main-admin-sponsors-create',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminSponsors.vue'),
                },
                {
                  path: 'sponsors/create',
                  component: () => import(
                    './views/main/admin/AdminCreateSponsor.vue'
                  )
                },
                {
                  path: 'sponsors/edit/:id',
                  name: 'main-admin-sponsors-edit',
                  component: () => import(
                    './views/main/admin/AdminEditSponsor.vue'
                  )
                },
                
              ],
            },
            {
              path: 'manage',
              component: () => import(/* webpackChunkName: "main-manage" */ './views/main/manage/Manage.vue'),
              redirect: 'main/dashboard',
              children: [
                {
                  path: 'employees',
                  component: () => import(
                    './views/main/manage/Employees.vue'
                  ),
                },
                {
                  path: 'menu',
                  component: () => import (
                    './views/main/manage/Menu.vue'
                  )
                },
                {
                  path: 'menu/new-item',
                  component: () => import('./views/main/manage/NewMenuItem.vue'),
                },
                {
                  path: 'menu/edit/:itemId',
                  name: 'menu-edit-item',
                  component: () => import('./views/main/manage/EditMenuItem.vue'),
                },
                {
                  path: 'tables',
                  name: 'tables',
                  component: () => import('./views/main/manage/Tables.vue'),
                },
                {
                  path: 'devices',
                  name: 'devices',
                  component: () => import('./views/main/manage/Devices.vue'),
                },
                {
                  path: 'order',
                  component: () => import('./views/main/order/Order.vue'),
                },
                {
                  path: 'settings',
                  component: () => import(
                    './views/main/manage/Settings.vue'),
                },
                {
                  path: 'inventory',
                  component: () => import(
                    './views/main/manage/Inventory.vue'),
                 
                }
              ]
            }
          ],
        },
      ],
    },
    {
      path: '/*', redirect: '/',
    },
  ],
});
